export const CONNECTIONS = {
  NO_CONNECTIONS: 'no',
  EMPLOYEE: 'employee',
  COMPANY: 'company',
  ORGANIZER: 'organizer',
  UNKNOWN: 'unknown'
};

export const ID_CONNECTIONS_MAP = {
  16481: CONNECTIONS.EMPLOYEE,
  16482: CONNECTIONS.COMPANY,
  16513: CONNECTIONS.ORGANIZER
};
